var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurquoiseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8306 3.625V20.125C16.8306 21.9713 18.1075 23 19.4622 23C20.7153 23 22.0938 22.125 22.0938 20.125V3.75C22.0938 2.0575 20.8406 1 19.4622 1C18.0837 1 16.8306 2.16625 16.8306 3.625Z",
    fill: "#92F2F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93829 12.0001V20.1251C9.93829 21.9714 11.2152 23.0001 12.5699 23.0001C13.823 23.0001 15.2015 22.1251 15.2015 20.1251V12.1251C15.2015 10.4326 13.9483 9.37512 12.5699 9.37512C11.1914 9.37512 9.93829 10.5414 9.93829 12.0001Z",
    fill: "#74DDE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67755 23.0001C7.13094 23.0001 8.30915 21.8249 8.30915 20.3751C8.30915 18.9254 7.13094 17.7501 5.67755 17.7501C4.22416 17.7501 3.04596 18.9254 3.04596 20.3751C3.04596 21.8249 4.22416 23.0001 5.67755 23.0001Z",
    fill: "#74DDE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurquoiseLogo);
export default __webpack_public_path__ + "static/media/turquoise-logo.ef37694d0ebea35c98a304cc362ed969.svg";
export { ForwardRef as ReactComponent };